import { mapHoldType, mapPaginationType, useFindCompanyHolds } from '@api';
import {
  getTableParams,
  HoldsTable,
  ManageTableProvider,
  useManageTable,
} from '@common';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/companies/$id.holds';

export const CompanyPastHolds: React.FC = () => {
  const { t } = useTranslation('companyDetailsHolds');
  const { id: companyId } = Route.useParams();
  const { tableIdCompanyPastHolds: tableId } = Route.useRouteContext();

  const searchParams = Route.useSearch();
  const tableParams = getTableParams(searchParams, tableId);

  const { data, isFetching } = useFindCompanyHolds(
    companyId,
    {
      type: 'PAST',
      ...tableParams,
    },
    {
      query: {
        select: (response) => ({
          holds: response.data.map(mapHoldType),
          pagination: mapPaginationType(response.metadata.pagination),
        }),
      },
    }
  );

  const holds = data?.holds ?? [];
  const pagination = data?.pagination ?? mapPaginationType(undefined);

  const methods = useManageTable({
    navigateFn: Route.useNavigate(),
    searchParams,
    pagination,
    config: {},
    tableId,
  });

  return (
    <ManageTableProvider {...methods}>
      <HoldsTable
        title={t('PAST_HOLDS.TITLE')}
        holds={holds}
        isFetching={isFetching}
        dataTestId="company-past-holds-container"
      />
    </ManageTableProvider>
  );
};
